import { render, staticRenderFns } from "./no-data-found.component.vue?vue&type=template&id=eb3924a6"
import script from "./no-data-found.component.vue?vue&type=script&lang=ts"
export * from "./no-data-found.component.vue?vue&type=script&lang=ts"
import style0 from "./no-data-found.component.vue?vue&type=style&index=0&id=eb3924a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports